import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';
import { Button } from '../ui/button';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { faqs, companyInfo } from '../../data/mock';

const FAQSection = () => {
  return (
    <section className="py-12 md:py-16 section-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          {/* Left Column - Header & CTA */}
          <div className="lg:sticky lg:top-32 lg:self-start">
            <span className="inline-block text-[#B5D43B] font-semibold text-sm tracking-wider uppercase mb-4">
              Common Questions
            </span>
            <h2 className="heading-2 mb-5">
              Frequently Asked Questions
            </h2>
            <p className="body-large mb-8">
              Got questions? We've got answers. If you can't find what you're 
              looking for, our team is happy to help.
            </p>
            
            <div className="space-y-4">
              <Link to="/contact">
                <Button className="btn-primary gap-2">
                  Talk to Our Team
                  <ArrowRight className="w-4 h-4" />
                </Button>
              </Link>
              <div className="flex items-center gap-3 text-gray-600">
                <Phone className="w-4 h-4 text-[#B5D43B]" />
                <span>Or call us: <a href={`tel:${companyInfo.phone}`} className="font-medium text-[#3D5A47] hover:text-[#B5D43B] transition-colors">{companyInfo.phone}</a></span>
              </div>
            </div>
          </div>

          {/* Right Column - Accordion */}
          <div className="bg-white rounded-2xl border border-black/5 p-6 md:p-8">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, index) => (
                <AccordionItem 
                  key={index} 
                  value={`item-${index}`}
                  className="border-b border-black/5 last:border-0"
                >
                  <AccordionTrigger className="text-left font-semibold text-[#3D5A47] hover:text-[#B5D43B] hover:no-underline py-5">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600 leading-relaxed pb-5">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
